import { render, staticRenderFns } from "./ColorBlock.vue?vue&type=template&id=071be876&scoped=true&"
import script from "./ColorBlock.vue?vue&type=script&lang=js&"
export * from "./ColorBlock.vue?vue&type=script&lang=js&"
import style0 from "./ColorBlock.vue?vue&type=style&index=0&id=071be876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071be876",
  null
  
)

export default component.exports